import "./AlertMessage.scss";

import React, { useState } from "react";

import CreateTrialModal from "./TrialLessonModal";
import { ShieldAlertIcon } from "lucide-react";

interface AlertMessageProps {
  title: string;
}

const AlertMessage: React.FC<AlertMessageProps> = ({ title }) => {
  const [showModal, setShowModal] = useState(false);
  // const handleCloseModal = () => setShowModal(false);

  return (
    <div className="alert-message" role="alert">
      <div className="alert-icon">
        <ShieldAlertIcon />
      </div>
      <div className="alert-content">
        <p className="alert-title">{title}</p>
        <p className="alert-text">
          Before creating specialized courses or intensive packages, set up a
          30-minute introductory session.
        </p>
        <div className="alert-actions">
          <button
            className="btn btn-trial-lesson"
            onClick={() => setShowModal(true)}
          >
            + Create Trail Lesson
          </button>
        </div>
      </div>

      {showModal && (
        <div className="modalBackdrop">
          <div className="modalWrapper">
            <CreateTrialModal handleCloseModal={() => setShowModal(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertMessage;
